import React, { useEffect, useState } from "react";

// Live countdown to a session's game-window expiry (`gameWindowEndsAt`, unix ms,
// returned by GET /lobby as `userActiveSession.gameWindowEndsAt`). Note our
// window timer does not perfectly align with the game's own internal timer, so
// this is a best-effort indication, not a guarantee.
const format = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
};

const SessionCountdown = ({ endsAt, className = "" }) => {
  const [remaining, setRemaining] = useState(() =>
    endsAt ? endsAt - Date.now() : 0,
  );

  useEffect(() => {
    if (!endsAt) return undefined;
    setRemaining(endsAt - Date.now());
    const id = setInterval(() => {
      setRemaining(endsAt - Date.now());
    }, 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (!endsAt) return null;

  const expired = remaining <= 0;

  return (
    <div
      className={`flex flex-col items-center gap-1 ${className}`}
      role="timer"
      aria-live="off"
    >
      <span className="text-[10px] font-black uppercase tracking-[0.2em] text-darkGray font-inter">
        {expired ? "Session expired" : "Time left"}
      </span>
      <span
        className={`text-[28px] leading-none font-black font-saira tabular-nums ${
          expired ? "text-darkGray" : "text-brand"
        }`}
      >
        {format(remaining)}
      </span>
    </div>
  );
};

export default SessionCountdown;
